import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

export const deviceOrderSpecificationValidationSchema = () =>
  createValidationSchema({
    deviceOrderSpecifications: commonValidationSchemas.string(),
  });
